/// <reference types="@angular/localize" />

import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (!isDevMode()) {
  Sentry.init({
    dsn: "https://625aee85d187982bfc7b9fe9bc4b4113@o4509207551410176.ingest.de.sentry.io/4509237143404624",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
